import { LayoutDashboard, User, Workflow } from "lucide-react";

export const getMenuItems = (user) => {
  const items = [
    {
      label: "Dashboard",
      path: "/portal/dashboard",
      permission: null,
      icon: LayoutDashboard,
    },
    {
      label: "Users",
      path: "/portal/users",
      permission: "Onboarding Manager",
      icon: User,
    },
    {
      label: "Workflows",
      path: "/portal/workflows",
      permission: null,
      icon: Workflow,
    },
  ];

  return items.filter(
    (item) =>
      !item.permission ||
      user?.role === "super_admin" ||
      user?.permissions?.includes(item.permission),
  );
};
